const catalogSortOrders = {
    /*eslint-disable */
    DATE_ASCENDING: 'DATE_ASCENDING',
    DATE_DESCENDING: 'DATE_DESCENDING',
    /*eslint-enable */
} as const;

export default catalogSortOrders;
